import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { ControlBase } from '../base/base.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'form-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzSwitchModule, ReactiveFormsModule],
  template: `
    <nz-switch
      [class]="baseClasses"
      [formControl]="control()"
      [nzSize]="'small'"
    ></nz-switch>
  `,
})
export class ControlSwitchComponent extends ControlBase {}
